// Versandkostenberechnung nach Paketgewicht.
//
// Bruttogewicht = Fuellmenge + Leergewicht des Glases. Ein 500g-Glas wiegt
// leer rund 200g, ein 250g-Glas rund 100g — in beiden Faellen also 40% der
// Fuellmenge. Ein 500g-Produkt zaehlt damit als 700g, ein 250g-Produkt als
// 350g.
const TARE_RATIO = 0.4;
const TARE_BY_FILL = { 250: 100, 500: 200 };

export const SHIPPING_THRESHOLD_GRAMS = 2000;
export const SHIPPING_COST_LIGHT = 9;
export const SHIPPING_COST_HEAVY = 12;

// Liest Fuellmenge und Stueckzahl aus dem Produkttitel, z.B. "Wald 500g"
// oder "Weihnachtsduo 2x 250g".
export function itemGrossWeight(subtitle) {
  if (!subtitle) return 0;
  const match = /(?:(\d+)\s*x\s*)?(\d+)\s*g\b/i.exec(subtitle);
  if (!match) return 0;
  const count = match[1] ? parseInt(match[1], 10) : 1;
  const fill = parseInt(match[2], 10);
  const tare = TARE_BY_FILL[fill] != null ? TARE_BY_FILL[fill] : Math.round(fill * TARE_RATIO);
  return count * (fill + tare);
}

export function cartGrossWeight(addedItems) {
  if (!addedItems) return 0;
  return addedItems.reduce(
    (grams, item) => grams + itemGrossWeight(item.subtitle) * (item.quantity || 0),
    0
  );
}

export function shippingCostForWeight(grams) {
  if (!grams) return 0;
  return grams <= SHIPPING_THRESHOLD_GRAMS ? SHIPPING_COST_LIGHT : SHIPPING_COST_HEAVY;
}

export function formatWeight(grams) {
  return grams >= 1000 ? (grams / 1000).toFixed(2) + " kg" : grams + " g";
}
